import React from 'react';

export const StatCard = ({
  title,
  value,
  subtitle = null,
  className = ''
}) => {
  return (
    <div className={`bg-white rounded-lg shadow p-6 ${className}`}>
      <div className="text-sm font-medium text-gray-600 mb-2">
        {title}
      </div>
      <div className="text-2xl font-bold text-gray-900">
        {value}
      </div>
      {subtitle && (
        <div className="mt-2 text-sm text-gray-600">
          {subtitle}
        </div>
      )}
    </div>
  );
};

export default StatCard;
